<template>
    <div class="card-header-block">
        <el-select v-model="type" @change="changeType" size="mini" style="width: 150px">
            <el-option v-for="item in typeList" :key="item.value" :label="item.text" :value="item.value"> </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name: "SelectChartValueType",
    data() {
        return {
            typeList: [
                { value: "1", text: "客流量 (人次)" },
                { value: "2", text: "集客力 (人/㎡)" },
                { value: "3", text: "销售额 (元)" },
                { value: "4", text: "提袋率 (%)" },
                { value: "5", text: "客单价 (元/人次)" },
                { value: "6", text: "坪效 (㎡)" },
            ],
            type: "1",
        };
    },
    methods: {
        changeType() {
            this.$emit("change", this.type);
        },
    },
};
</script>
